import { PeriodKey } from '@/ts/composables/usePeriod';

interface Period {
  name: string;
  key: PeriodKey;
}

interface PeriodGroup {
  groupName: string;
  measurements: Period[];
}

const PERIOD_GROUPS: PeriodGroup[] = [
  {
    groupName: 'PERIOD',
    measurements: [
      { name: '1D Change', key: 'oneday' },
      { name: '2D Change', key: 'twoday' },
      { name: '5D Change', key: 'fiveday' },
      { name: '1M Change', key: 'onemonth' },
      { name: '3M Change', key: 'threemonth' },
      { name: '6M Change', key: 'sixmonth' },
      { name: '9M Change', key: 'ninemonth' },
      { name: 'YTD Change', key: 'yeartodate' },
      { name: '1Y Change', key: 'oneyear' }
    ]
  }
];

export {
  PERIOD_GROUPS
}

